import { Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Box, } from '@mui/system'
import React, { useEffect, useState } from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { Item } from '../../../common/snippets'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { callAddFontRobotoBold } from "../../../common/font/Roboto-bold"
import { callAddFontRobotoMedium } from "../../../common/font/Roboto-Medium-normal"
import { userWiseExcelDetailHeader, } from '../analysisReport/constants'
import { focusElemnt, navigation3 } from '../../../common/helper'
import { useAtom } from 'jotai'
import { companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { getcolumnDefs, getColumnStyle, getSubheading, getTotalRow, HeaderColumn, tableHeadObject } from './constants'
const newObj={BKNG:'Booking',DEL:'Delivery',RFND:'Refund'}
const DetailedTable = ({ disableExcel, userDetail, tableData, loginData, tableData2, selBranch, UserName, fromDate, toDate, transaction, paymentMode, paymentType, cargoSettingFilterData }) => {
  const [showTableData, setShowTableData] = useState([])
  const [searchResult, setSearchResult] = useState(true)
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const [companySettings] = useAtom(companySettingsAtom)
  const { UseFormattedLRinReports } = companySettings
  const loginCountryId = companySettings?.DefaultCurrencyID
  const { generatePDF, load } = { ...state }
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
  let isTableOne = true
  const columnDefs = getcolumnDefs(UseFormattedLRinReports, loginCountryId, isTableOne)
  const col = columnDefs.length
  const subHeading = getSubheading(col)
  const totalcol = getTotalRow(UseFormattedLRinReports, loginCountryId)
  useEffect(() => {
    if (tableData?.length > 0) {
      paymentWiseGroupData(tableData)
    } else {
      setShowTableData([])
    }
  }, [tableData])
  const groupData = (key, array) => {
    var newData = {};
    array.forEach((item) => {
      if (!(item[key] in newData)) {
        newData[item[key]] = [];
      }
      newData[item[key]].push({...item
      });
    });
    return newData;
  };
  const transactionWiseGroupData = (array) => {
    var newData = groupData("Transaction", array);
    Object.keys(newData).map((val) => {
      const totals = newData[val].reduce(
        (acc, item) => {
          acc.Totalquantity += Number(item.Quantity);
          acc.totalLRAmt += Number(item.LRAmount);
          acc.totalOtherChanges += Number(item.OtherCharges);
          acc.totalAmount += Number(item.Amount);
          acc.totalDelExpense += Number(item.DeliveryExpense);
          acc.netTotalAmount += Number(item.TotalAmount);
          return acc;
        },
        {
          Totalquantity: 0,
          totalLRAmt: 0,
          totalOtherChanges: 0,
          totalAmount: 0,
          totalDelExpense: 0,
          netTotalAmount: 0,
        }
      );

      const {
        Totalquantity,
        totalLRAmt,
        totalOtherChanges,
        totalAmount,
        totalDelExpense,
        netTotalAmount,
      } = totals;

      // Add transaction total row
      newData[val].push({
        SN: `Total Amount:${newData[val]?.[0]?.Transaction} `,
        Quantity: Totalquantity,
        LRAmount: totalLRAmt.toFixed(2),
        OtherCharges: totalOtherChanges.toFixed(2),
        Amount: totalAmount.toFixed(2),
        DeliveryExpense: totalDelExpense.toFixed(2),
        TotalAmount: netTotalAmount.toFixed(2),
        isTotal: true,
        Transaction: newData[val]?.[0]?.Transaction,
      });

      // Subheading
      newData[val].unshift({
        SN: `Transaction:${val}`,
        FromCity: `State: ${userDetail?.[0]?.Statename}`,
        ConsignmentType: `City Name: ${userDetail?.[0]?.Cityname}`,
        LRAmount: `Branch: ${userDetail?.[0]?.Branchname}`,
        isSubHeading: true,
      });

      // Table heading
      const tableH = tableHeadObject(val);
      if (UseFormattedLRinReports === 3) {
        tableH.FormattedLRNO = "Formatted LRNO";
      }
      newData[val].unshift(tableH);
    });

    Object.keys(newData).forEach((item) => {
      newData[item]?.forEach((val, i) => {
        if (Object.keys(val).length === 18) {
          val.SN = i - 1;
        }
      });
    });

    const mainData = { ...newData };
    return Object.values(mainData).flat();
  };
  const paymentWiseGroupData = (array) => {
    if (array.length < 1) {
      return;
    }
    const newArray = array.map((item) => ({
      ...item,
      Transaction:newObj[item.TranType]||''
    }));
    const newData = groupData("PaymentMode", newArray);
    let data = [];
    let grandTotal = {
      Quantity: 0,
      LRAmount: 0,
      OtherCharges: 0,
      Amount: 0,
      DeliveryExpense: 0,
      TotalAmount: 0,
    };
    Object.keys(newData).forEach((paymentMode) => {
      const arr = transactionWiseGroupData(newData[paymentMode]);
      let pmTotal = {
        Quantity: 0,
        LRAmount: 0,
        OtherCharges: 0,
        Amount: 0,
        DeliveryExpense: 0,
        TotalAmount: 0,
      };
      arr.forEach((row) => {
        if (row.isTotal && !row.isPayAllTotal) {
          if (row.Transaction === "Refund") {
            pmTotal.Quantity -= Number(row.Quantity);
            pmTotal.LRAmount -= Number(row.LRAmount);
            pmTotal.OtherCharges -= Number(row.OtherCharges);
            pmTotal.Amount -= Number(row.Amount);
            pmTotal.DeliveryExpense -= Number(row.DeliveryExpense);
            pmTotal.TotalAmount -= Number(row.TotalAmount);
          } else {
            pmTotal.Quantity += Number(row.Quantity);
            pmTotal.LRAmount += Number(row.LRAmount);
            pmTotal.OtherCharges += Number(row.OtherCharges);
            pmTotal.Amount += Number(row.Amount);
            pmTotal.DeliveryExpense += Number(row.DeliveryExpense);
            pmTotal.TotalAmount += Number(row.TotalAmount);
          }
        }
      });
      arr.push({
        SN: `Net ${paymentMode} Collection: ${UserName}`,
        Quantity: pmTotal.Quantity,
        LRAmount: pmTotal.LRAmount.toFixed(2),
        OtherCharges: pmTotal.OtherCharges.toFixed(2),
        Amount: pmTotal.Amount.toFixed(2),
        DeliveryExpense: pmTotal.DeliveryExpense.toFixed(2),
        TotalAmount: pmTotal.TotalAmount.toFixed(2),
        isTotal: true,
        isPayAllTotal: true,
      });

      // Heading for payment mode
      arr.unshift({ SN: `Payment Mode: ${paymentMode}`, isSupHeading: true });

      // Step 5: Add to grand totals
      grandTotal.Quantity += pmTotal.Quantity;
      grandTotal.LRAmount += pmTotal.LRAmount;
      grandTotal.OtherCharges += pmTotal.OtherCharges;
      grandTotal.Amount += pmTotal.Amount;
      grandTotal.DeliveryExpense += pmTotal.DeliveryExpense;
      grandTotal.TotalAmount += pmTotal.TotalAmount;

      // Merge into main data
      data = [...data, ...arr];
    });

    // Step 6: Add final grand total row
    data.push({
      SN: `Net All Payment Collection: ${UserName}`,
      Quantity: grandTotal.Quantity,
      LRAmount: grandTotal.LRAmount.toFixed(2),
      OtherCharges: grandTotal.OtherCharges.toFixed(2),
      Amount: grandTotal.Amount.toFixed(2),
      DeliveryExpense: grandTotal.DeliveryExpense.toFixed(2),
      TotalAmount: grandTotal.TotalAmount.toFixed(2),
      isTotal: true,
    });
    data.push({
      SN: `LESS : Daily Expense Amount`,
      TotalAmount: (tableData2?.[0]?.DailyExpense).toFixed(2),
      isExpense: true
    });
    data.push({
      SN: `Net All Payment Collection - Expenses: ${UserName}`,
      TotalAmount: (grandTotal.TotalAmount - Math.abs(tableData2?.[0]?.DailyExpense || 0)).toFixed(2),
      isNetCollection: true
    });
    if (cargoSettingFilterData?.[0]?.IsConvCharge === 1) {
      data.push({
        SN: `Total All Payment Collection + Convenience Fee : ${UserName}`,
        TotalAmount: (tableData2?.[0]?.TotalConvCharge + grandTotal.TotalAmount).toFixed(2),
        ConvCharge: true
      });
    }
    setShowTableData(data);
  };
  const printClick = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
    jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);
    const pdfColumns = columnDefs.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = HeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderData = [
      {
        Branch: selBranch?.BranchName,
        User: UserName,
        TransactionType: transaction?.Transactions,
        PaymentType: paymentType?.name,
        PaymentMode: paymentMode?.ModeName
      },
    ]
    const doc = new jsPDF({ orientation: 'p', format: [1239, 1754], unit: 'px', compress: true })

    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(16)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
    }

    let drawCell = function (data) {
      var rows = data.table.body
      rows.map((val) => {
        if (Object.keys(val.raw).length == 1) {
          val.cells[0].colSpan = col
          val.cells[0].styles.font = 'Roboto'
          val.cells[0].styles.fontStyle = 'normal'
          val.cells[0].styles.fontSize = '16'
          val.cells[0].styles.textColor = [0, 0, 0]
          val.cells[0].styles.halign = 'left'
          val.cells[0].styles.fillColor = [191, 225, 255]
        }
        if (val.raw.isSupHeading) {
          val.cells[0].colSpan = col
          val.cells[0].styles.font = 'Roboto'
          val.cells[0].styles.fontStyle = 'normal'
          val.cells[0].styles.fontSize = '16'
          val.cells[0].styles.textColor = [0, 0, 0]
          val.cells[0].styles.halign = 'left'
          val.cells[0].styles.fillColor = [218, 237, 254]
        }
        if (val.raw.isSubHeading) {
          const baseColIndex = 0;
          const columnValue2 = UseFormattedLRinReports === 3 ? 4 : 4;

          // First subheading cell
          val.cells[baseColIndex].colSpan = columnValue2;
          Object.assign(val.cells[baseColIndex].styles, {
            font: 'Roboto',
            fontStyle: 'normal',
            fontSize: 16,
            textColor: [0, 0, 0],
            halign: 'left',
            fillColor: [233, 245, 255]
          });

          const col2 = columnValue2;
          val.cells[col2].colSpan = 3;
          Object.assign(val.cells[col2].styles, {
            font: 'Roboto',
            fontStyle: 'normal',
            fontSize: 16,
            textColor: [0, 0, 0],
            halign: 'left',
            fillColor: [233, 245, 255]
          });

          const col3 = col2 + 3;
          val.cells[col3].colSpan = 3;
          Object.assign(val.cells[col3].styles, {
            font: 'Roboto',
            fontStyle: 'normal',
            fontSize: 16,
            textColor: [0, 0, 0],
            halign: 'left',
            fillColor: [233, 245, 255]
          });

          const col4 = col3 + 3;
          val.cells[col4].colSpan = 4;
          Object.assign(val.cells[col4].styles, {
            font: 'Roboto',
            fontStyle: 'normal',
            fontSize: 16,
            textColor: [0, 0, 0],
            fillColor: [233, 245, 255]
          });
        }

        if (val.raw.ConvCharge) {
          let columnValue1 = UseFormattedLRinReports === 3 ? 9 : 8
          val.cells[0].colSpan = columnValue1
          val.cells[0].styles.font = 'Roboto'
          val.cells[0].styles.fontStyle = 'normal'
          val.cells[0].styles.fontSize = '16'
          val.cells[0].styles.textColor = [0, 0, 0]
          val.cells[0].styles.halign = 'right'
          val.cells[`${columnValue1}`].colSpan = 4
          val.cells[`${columnValue1}`].styles.font = 'Roboto'
          val.cells[`${columnValue1}`].styles.fontStyle = 'normal'
          val.cells[`${columnValue1}`].styles.fontSize = '16'
          val.cells[`${columnValue1}`].styles.textColor = [0, 0, 0]
          val.cells[`${columnValue1}`].styles.halign = 'right'
        }
        if (val.raw.isTotal || val.raw.isExpense || val.raw.isNetCollection) {
          let columnValue = UseFormattedLRinReports === 3 ? 10 : 9
          val.cells[0].colSpan = columnValue
          val.cells[0].styles.font = 'Roboto'
          val.cells[0].styles.fontStyle = 'normal'
          val.cells[0].styles.fontSize = '16'
          val.cells[0].styles.textColor = [0, 0, 0]
          val.cells[0].styles.halign = 'right'
          val.cells[0].styles.fillColor = [238, 238, 238]
          val.cells[`${columnValue}`].colSpan = 1
          val.cells[`${columnValue}`].styles.font = 'Roboto'
          val.cells[`${columnValue}`].styles.fontStyle = 'normal'
          val.cells[`${columnValue}`].styles.fontSize = '16'
          val.cells[0].styles.textColor = [0, 0, 0]
          val.cells[`${columnValue}`].styles.halign = "right"
          val.cells[`${columnValue}`].styles.fillColor = [238, 238, 238]
          val.cells[`${columnValue + 1}`].colSpan = 1
          val.cells[`${columnValue + 1}`].styles.font = 'Roboto'
          val.cells[`${columnValue + 1}`].styles.fontStyle = 'normal'
          val.cells[`${columnValue + 1}`].styles.fontSize = '16'
          val.cells[0].styles.textColor = [0, 0, 0]
          val.cells[`${columnValue + 1}`].styles.halign = 'right'
          val.cells[`${columnValue + 1}`].styles.fillColor = [238, 238, 238]
          val.cells[`${columnValue + 2}`].colSpan = 1
          val.cells[`${columnValue + 2}`].styles.font = 'Roboto'
          val.cells[`${columnValue + 2}`].styles.fontStyle = 'normal'
          val.cells[`${columnValue + 2}`].styles.fontSize = '16'
          val.cells[0].styles.textColor = [0, 0, 0]
          val.cells[`${columnValue + 2}`].styles.halign = 'right'
          val.cells[`${columnValue + 2}`].styles.fillColor = [238, 238, 238]
          val.cells[`${columnValue + 3}`].colSpan = 1
          val.cells[`${columnValue + 3}`].styles.font = 'Roboto'
          val.cells[`${columnValue + 3}`].styles.fontStyle = 'normal'
          val.cells[`${columnValue + 3}`].styles.fontSize = '16'
          val.cells[0].styles.textColor = [0, 0, 0]
          val.cells[`${columnValue + 3}`].styles.halign = 'right'
          val.cells[`${columnValue + 3}`].styles.fillColor = [238, 238, 238]
          val.cells[`${columnValue + 4}`].colSpan = 1
          val.cells[`${columnValue + 4}`].styles.font = 'Roboto'
          val.cells[`${columnValue + 4}`].styles.fontStyle = 'normal'
          val.cells[`${columnValue + 4}`].styles.fontSize = '16'
          val.cells[0].styles.textColor = [0, 0, 0]
          val.cells[`${columnValue + 4}`].styles.halign = "right"
          val.cells[`${columnValue + 4}`].styles.fillColor = [238, 238, 238]
        }
        if (val.raw.isHeading) {
          for (let i = 0; i < col; i++) {
            val.cells[i].colSpan = 1
            val.cells[i].styles.font = 'Roboto'
            val.cells[i].styles.fontStyle = 'normal'
            val.cells[i].styles.fontSize = '16'
            val.cells[0].styles.textColor = [0, 0, 0]
            val.cells[i].styles.fillColor = [218, 237, 254]
          }
        }
      })
    }

    doc.setProperties({
      title: `User Wise Collection With Delivery Expense.pdf`,
      subject: 'User Wise Collection With Delivery Expense Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })


    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        1: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        2: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        3: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        4: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        doc.text(`Collection Date: ${moment(fromDate).format("DD-MMM-YYYY")} To ${moment(toDate).format("DD-MMM-YYYY")} `, data.settings.margin.left, 150)
        doc.text(`Report View: Summary`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
      },
    })

    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0]
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: [{ SN: `Detailed View (${UserName})` }, ...showTableData] || [],
      styles: {
        lineWidth: [0, 0.2, 0, 0.2]
      },
      columnStyles: getColumnStyle(UseFormattedLRinReports === 3),
      theme: 'grid',
      showHead: "never",
      didParseCell: (data) => {
        drawCell(data)
      },
      willDrawCell: (data) => {
        if (data.row.raw.ConvCharge) {
          doc.setFillColor(238, 238, 238);
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(16).setFont("Roboto", 'normal')
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Userwise Collection Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`UserWiseCollection Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('userWiseCollectionoutput').data = pdfUrl
        document.getElementById('userWiseCollectionoutput').data = doc.output('datauristring', 'UserWiseCollection.pdf')
        focusElemnt("UWBackBtn")
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('userWiseCollectionoutput').data = pdfUrl
        // document.getElementById('userWiseCollectionoutput').data = doc.output('datauristring', 'UserWiseCollection.pdf')
        focusElemnt("UWBackBtn")
      }, 2000)
    }
  }
  const InsideRowContentForExcel = ({ item, index }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        {item.isSupHeading ? (
          <>
            <TableCell
              className="userWiseReportHeading"
              colSpan={col}
              style={{ color: '#444444', fontSize: '20px', backgroundColor: '#DAEDFE' }}
            >
              {item.SN}
            </TableCell>
          </>
        ) : item.isHeading ? (
          <>
            {columnDefs.map((columm, index) => {
              return (
                <TableCell
                  className="userWiseReportHeading"
                  key={'sdfdsse' + index}
                  style={{
                    color: '#444444',
                    fontSize: '20px',
                    backgroundColor: '#DAEDFE',
                    width: index === 0 ? '60px' : undefined,
                    textAlign: columm.xlCol.dataType === 'quantity' ? 'right' : 'left',
                  }}
                >
                  {columm.field === 'DeliveryExpense' ? item.DeliveryExpense : columm.headerName}
                </TableCell>
              )
            })}
          </>
        ) : item.isSubHeading ? (
          <>
            {subHeading.map((head, index) => {
              return (
                <TableCell
                  className="userWiseReportSubHeading"
                  key={'xd03sc' + index}
                  style={{ fontSize: '20px', backgroundColor: '#F2F9FF', color: '#444444', textAlign: head?.textAlign }}
                  colSpan={head.colspan}
                >
                  {item[head.headerName]}
                </TableCell>
              )
            })}
          </>
        ) : item.ConvCharge ? (
          <>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={col - 6}
              style={{ fontWeight: '700', fontSize: '20px', textAlign: 'right', minHeight: '36px' }}
            >
              {item.SN}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={4}
              style={{ textAlign: 'right', fontWeight: '700', fontSize: '20px', minHeight: '36px' }}
            >
              {item.TotalAmount}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={2}
              style={{ textAlign: 'right', fontWeight: '700', fontSize: '20px', minHeight: '36px' }}
            >
              {/* {item.TotalAmount} */}
            </TableCell>
          </>
        ) : item.isTotal ? (
          <>
            {totalcol.map((head, index) => (
              <TableCell
                key={'sdcs230sd' + index}
                className="userWiseReportSubTotal"
                style={{ textAlign: 'right', fontWeight: '700', fontSize: '20px', backgroundColor: '#eeeeee' }}
                colSpan={head.colspan}
              >
                {item[head.headerName]}
              </TableCell>
            ))}
          </>
        ) : item.isExpense ? (
          <>
            <TableCell
              key={'sdcs230sd'}
              className="userWiseReportSubTotal"
              style={{ textAlign: 'right', fontWeight: '700', fontSize: '20px', backgroundColor: '#eeeeee' }}
              colSpan={UseFormattedLRinReports === 3 ? 9 : 8}
            >
              {item.SN}
            </TableCell>
            <TableCell
              key={'sdcs230sd'}
              className="userWiseReportSubTotal"
              style={{ textAlign: 'right', fontWeight: '700', fontSize: '20px', backgroundColor: '#eeeeee' }}
              colSpan={6}
            >
              {item.TotalAmount}
            </TableCell>
          </>
        ) : item.isNetCollection ? (
          <>
            <TableCell
              key={'sdcs230sd'}
              className="userWiseReportSubTotal"
              style={{ textAlign: 'right', fontWeight: '700', fontSize: '20px', backgroundColor: '#eeeeee' }}
              colSpan={UseFormattedLRinReports === 3 ? 9 : 8}
            >
              {item.SN}
            </TableCell>
            <TableCell
              key={'sdcs230sd'}
              className="userWiseReportSubTotal"
              style={{ textAlign: 'right', fontWeight: '700', fontSize: '20px', backgroundColor: '#eeeeee' }}
              colSpan={6}
            >
              {item.TotalAmount}
            </TableCell>
          </>
        ) : (
          <>
            {columnDefs.map((columm, index) => {
              return (
                <TableCell
                  className="userwiseTD"
                  key={'sdfdsse' + index}
                  style={{
                    fontSize: '20px',
                    width: index === 0 ? '10px' : undefined,
                    paddingLeft: index === 0 ? '10px' : undefined,
                    textAlign: columm.xlCol.dataType === 'quantity' ? 'right' : 'left',
                  }}
                >
                  {item[columm.field]}
                </TableCell>
              )
            })}
          </>
        )}
      </TableRow>
    )
  }
  const InsideRowContent = ({ item, index }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        {item.isSupHeading ? (
          <>
            <TableCell
              className="userWiseReportHeading"
              colSpan={isTableOne ? 15 : 13}
              style={{ paddingLeft: '10px', color: '#444444', backgroundColor: '#DAEDFE', position: 'sticky', top: '30px' }}
            >
              {item.SN}
            </TableCell>
          </>
        ) : item.isHeading ? (
          <>
            {columnDefs.map((columm, index) => {
              return (
                <TableCell
                  className="userWiseReportHeading"
                  key={'sdfdsse' + index}
                  style={{
                    color: '#444444',
                    backgroundColor: '#DAEDFE',
                    position: 'sticky',
                    top: '60px',
                    position: 'sticky',
                    top: '60px',
                    width: index === 0 ? '10px' : undefined,
                    paddingLeft: index === 0 ? '10px' : undefined,
                    whiteSpace: index === 0 ? 'nowrap' : undefined,
                    textAlign: columm.xlCol.dataType === 'quantity' ? 'right' : 'left',
                  }}
                >
                  {columm.field === 'DeliveryExpense' ? item.DeliveryExpense : columm.headerName}
                </TableCell>
              )
            })}
          </>
        ) : item.isSubHeading ? (
          <>
            {subHeading.map((head, index) => {
              return (
                <TableCell
                  className="userWiseReportSubHeading"
                  key={'xd03sc' + index}
                  style={{
                    padding: '10px 15px',
                    backgroundColor: '#F2F9FF',
                    fontWeight: 700,
                    color: '#444444',
                    textAlign: head?.textAlign,
                  }}
                  colSpan={head.colspan}
                >
                  {item[head.headerName]}
                </TableCell>
              )
            })}
          </>
        ) : item.ConvCharge ? (
          <>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={col - 6}
              style={{ paddingLeft: '10px', backgroundColor: '#eeeeee', textAlign: 'right', minHeight: '36px' }}
            >
              {item.SN}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={4}
              style={{ textAlign: 'right', backgroundColor: '#eeeeee', minHeight: '36px' }}
            >
              {item.TotalAmount}
            </TableCell>
            <TableCell
              className="userWiseReportSubTotal"
              colSpan={2}
              style={{ textAlign: 'right', backgroundColor: '#eeeeee', minHeight: '36px' }}
            >
              {/* {item.TotalAmount} */}
            </TableCell>
          </>
        ) : item.isTotal ? (
          <>
            {totalcol.map((head, index) => (
              <TableCell
                key={'sdcs230sd' + index}
                className="userWiseReportSubTotal"
                style={{ textAlign: 'right', backgroundColor: '#eeeeee', minHeight: '36px' }}
                colSpan={head.colspan}
              >
                {item[head.headerName]}
              </TableCell>
            ))}
          </>
        ) : item.isExpense ? (
          <>
            <TableCell
              key={'sdcs230sd'}
              className="userWiseReportSubTotal"
              style={{ textAlign: 'right', backgroundColor: '#eeeeee', minHeight: '36px' }}
              colSpan={UseFormattedLRinReports === 3 ? 9 : 8}
            >
              {item.SN}
            </TableCell>
            <TableCell
              key={'sdcs230sd'}
              className="userWiseReportSubTotal"
              style={{ textAlign: 'right', backgroundColor: '#eeeeee', minHeight: '36px' }}
              colSpan={6}
            >
              {item.TotalAmount}
            </TableCell>
          </>
        ) : item.isNetCollection ? (
          <>
            <TableCell
              key={'sdcs230sd'}
              className="userWiseReportSubTotal"
              style={{ textAlign: 'right', backgroundColor: '#eeeeee', minHeight: '36px' }}
              colSpan={UseFormattedLRinReports === 3 ? 9 : 8}
            >
              {item.SN}
            </TableCell>
            <TableCell
              key={'sdcs230sd'}
              className="userWiseReportSubTotal"
              style={{ textAlign: 'right', backgroundColor: '#eeeeee', minHeight: '36px' }}
              colSpan={6}
            >
              {item.TotalAmount}
            </TableCell>
          </>
        ) : (
          <>
            {columnDefs.map((columm, index) => {
              return (
                <TableCell
                  className="userwiseTD"
                  key={'sdfdsse' + index}
                  style={{
                    fontSize: '12px',
                    width: index === 0 ? '10px' : undefined,
                    paddingLeft: index === 0 ? '10px' : undefined,
                    textAlign: columm.xlCol.dataType === 'quantity' ? 'right' : 'left',
                  }}
                >
                  {item[columm.field]}
                </TableCell>
              )
            })}
          </>
        )}
      </TableRow>
    )
  }
  return (
    <>
      <Stack style={{ margin: "0px 10px", marginRight: "0px" }}>
        <Item className='userReport'>
          <Item className='userReport-heading'>
            Report For: User Wise Collection With Delivery Expense Report
          </Item>
          <Item className='userReport-buttons'>
            {
              searchResult ? <>
                {disableExcel ?
                  <Box>
                    <Button variant="outlined" className="userWisereporttembtn" disabled={true}>Export to Excel</Button>
                  </Box>
                  :
                  <Box onKeyDown={(e) => navigation3(e, "UWExpToPdfBtn", "UWSplitButton", () => { })}>
                    <ReactHtmlTableToExcel
                      id="UWExpToExsl"
                      className="userWisereporttemExcelBtn"
                      table="table-userWiseDetailReport-xls"
                      filename={`User Wise Collection With Delivery Expense Report ${currentDateTime}`}
                      sheet="tablexls"
                      buttonText="Export to Excel"
                    />
                  </Box>}
                <Box>
                  <Button id="UWExpToPdfBtn" variant="outlined" className="userWisereporttembtn"
                    onClick={() => { setSearchResult(false); printClick(true) }}
                    onKeyDown={(e) => navigation3(e, "UWPrintPdfBtn", disableExcel ? "UWSplitButton" : "UWExpToExsl", () => { setSearchResult(false); printClick(true) })}
                  >
                    Export to Pdf
                  </Button>
                </Box>
                <Box>
                  <Button id="UWPrintPdfBtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    onClick={() => { setSearchResult(false); printClick(false) }}
                    onKeyDown={(e) => navigation3(e, "UWFromDate", "UWExpToPdfBtn", () => { setSearchResult(false); printClick(false) })}
                  >
                    Print
                  </Button>
                </Box>
              </> : <>
                <Box>
                  <Button id="UWBackBtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    onClick={() => { setSearchResult(true) }}
                    onKeyDown={(e) => navigation3(e, "UWFromDate", "UWSplitButton", () => { setSearchResult(true); focusElemnt("UWSplitButton") })}
                  >
                    Back
                  </Button>
                </Box>
              </>
            }
          </Item>


        </Item>
      </Stack>
      {
        searchResult ?
          <Stack sx={{ marginLeft: 2, marginRight: 1, height: 470 }} className="scroll">
            <TableContainer className="lr-popup-table lrModel " component={Paper} style={{ borderRadius: "6px" }}>
              <Table size="small" aria-label="a dense table">
                <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                  <TableRow className='sammary-heading'>
                    <TableCell colSpan={isTableOne ? 15 : 13} style={{ fontSize: "12px", fontWeight: "900", paddingLeft: "10px", textAlign: "left", backgroundColor: "#BFE1FF", color: "#444444" }}>Detailed View ({UserName})</TableCell>
                  </TableRow>
                </TableHead>
                {showTableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={11}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) :
                  showTableData.length > 1 ? (
                    <TableBody className="filter-data-row" style={{ border: "none" }}>
                      {showTableData?.map((item, index) => (
                        <InsideRowContent item={item} index={index} key={index} />
                      ))}
                    </TableBody>
                  ) : (
                    ''
                  )}
              </Table>
              <Table id="table-userWiseDetailReport-xls" size="small" aria-label="a dense table" style={{ display: "none" }}>
                <TableHead style={{ fontWeight: 'bold' }}>
                  <TableRow>
                    <TableCell className="reportTD" style={{}} colSpan={7}>
                      <h3 style={{ fontSize: '24px', fontWeight: '600', textAlign: 'left' }}>Report For: User Wise Collection With Delivery Expense Report</h3>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={7}>
                      <h3 style={{ fontSize: '24px', fontWeight: '600', textAlign: 'left' }}>Company Name : {loginData?.strCompanyName}</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={13}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {userWiseExcelDetailHeader?.map((item, i) =>
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: "#444444", fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.value}
                      </TableCell>
                    )}
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                      colSpan={2}
                    >
                      {moment(fromDate).format('MM/DD/YYYY')}
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }}

                    >
                      {moment(toDate).format('MM/DD/YYYY')}
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                      colSpan={2}
                    >
                      {selBranch?.BranchName}
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                      colSpan={2}
                    >
                      {UserName}
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                      colSpan={2}
                    >
                      {transaction?.Transactions}
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }}

                    >
                      {paymentType?.name}
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }}

                    >
                      {paymentMode?.ModeName}
                    </TableCell>
                    <TableCell
                      className="reportTD"
                      style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }}

                    >
                      Detailed
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={12}></TableCell>
                  </TableRow>
                </TableHead>
                <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                  <TableRow className='sammary-heading'>
                    <TableCell colSpan={UseFormattedLRinReports === 3 ? 14 : loginCountryId !== 2 ? 13 : 12} style={{ fontSize: "20px", fontWeight: "900", textAlign: "left", backgroundColor: "#BFE1FF", color: "#444444" }}>Detailed View ({UserName})</TableCell>
                  </TableRow>
                </TableHead>
                {showTableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={12}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : showTableData.length > 1 ? (
                  <TableBody className="filter-data-row" style={{ border: "none" }}>
                    {showTableData?.map((item, index) => (
                      <InsideRowContentForExcel item={item} index={index} key={index} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
            </TableContainer>
          </Stack>
          :
          <>
            {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
            {load ? (
              <object
                id="userWiseCollectionoutput"
                type="application/pdf"
                width={"100%"}
                height="440"
                title="MTLPL -Cargo System - After Transfer Summary Report"
                aria-label="MTLPL -Cargo System - After Transfer Summary Report"
              ></object>
            ) : (
              ''
            )}
          </>
      }
    </>
  )
}

export default DetailedTable